var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0324 7.88197C48.0324 7.88197 47.5637 4.5726 46.1199 3.11947C44.2918 1.20697 42.2481 1.19759 41.3106 1.08509C34.5981 0.597595 24.5199 0.597595 24.5199 0.597595H24.5012C24.5012 0.597595 14.4231 0.597595 7.71056 1.08509C6.77306 1.19759 4.72931 1.20697 2.90118 3.11947C1.45743 4.5726 0.998059 7.88197 0.998059 7.88197C0.998059 7.88197 0.510559 11.7726 0.510559 15.6538V19.2913C0.510559 23.1726 0.988684 27.0632 0.988684 27.0632C0.988684 27.0632 1.45743 30.3726 2.89181 31.8257C4.71993 33.7382 7.11993 33.6726 8.18868 33.8788C12.0324 34.2445 24.5106 34.357 24.5106 34.357C24.5106 34.357 34.5981 34.3382 41.3106 33.8601C42.2481 33.7476 44.2918 33.7382 46.1199 31.8257C47.5637 30.3726 48.0324 27.0632 48.0324 27.0632C48.0324 27.0632 48.5106 23.182 48.5106 19.2913V15.6538C48.5106 11.7726 48.0324 7.88197 48.0324 7.88197ZM19.5512 23.707V10.2163L32.5168 16.9851L19.5512 23.707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0c31041f42ed306625295e9a353b0377.svg";
export { ForwardRef as ReactComponent };